module.exports = __webpack_public_path__ + "static/media/AB_W1_3.71424025.jpg";